import { PersonIdsEnum } from './persons';

export enum QuoteIdsEnum {
  onlineSeles,
  covidInfluence,
  offlineVsOnline,
  consumerFirst,
  massMediaPower,
  attitudeChanges,
  justMarketing,
  metaverse,
  personalizationAndPrivacy,
  sberEcosystem,
};

export interface QuoteInterface {
  author: PersonIdsEnum;
  text: string;
}

export const QUOTES: Record<QuoteIdsEnum, QuoteInterface> = {
  [QuoteIdsEnum.onlineSeles]: {
    author: PersonIdsEnum.emin,
    text: 'Онлайн-продажи малого и среднего бизнеса в России в пандемию росли выше, чем в среднем по миру: 32% против 28%. В том числе благодаря работе платформ.',
  },
  [QuoteIdsEnum.covidInfluence]: {
    author: PersonIdsEnum.daniil,
    text: 'В пандемию все стали использовать возможности, которые дают такие компании, как Facebook, «Яндекс», чтобы быстро выйти в онлайн.',
  },
  [QuoteIdsEnum.offlineVsOnline]: {
    author: PersonIdsEnum.daniil,
    text: 'В офлайновом мире у тебя было время на то, чтобы измениться. А в интернете все очень быстро.',
  },
  [QuoteIdsEnum.consumerFirst]: {
    author: PersonIdsEnum.sasha,
    text: 'Самое важное — знать своих потребителей, что их волнует. И уже потом использовать цифровую магию.',
  },
  [QuoteIdsEnum.massMediaPower]: {
    author: PersonIdsEnum.regina,
    text: 'Социальные медиа дают двустороннюю связь. Мы можем понимать в моменте, что работает, а что нет.',
  },
  [QuoteIdsEnum.attitudeChanges]: {
    author: PersonIdsEnum.regina,
    text: 'Сейчас мы выстраиваем с потребителями отношения другого уровня. Это не просто лояльность — это вовлечение.',
  },
  [QuoteIdsEnum.justMarketing]: {
    author: PersonIdsEnum.vlad,
    text: 'Нет деления на цифровой и нецифровой маркетинг, есть просто маркетинг. И это важная трансформация.',
  },
  [QuoteIdsEnum.metaverse]: {
    author: PersonIdsEnum.vlad,
    text: 'Через несколько лет даже такие далекие от видеоигр люди начнут жить в метавселенных, проводя там рабочие встречи, развлекаясь, взаимодействуя со своими детьми.',
  },
  [QuoteIdsEnum.personalizationAndPrivacy]: {
    author: PersonIdsEnum.anna,
    text: 'Совмещение персонализации рекламы и конфиденциальности данных — основа цифровых рекламных инструментов будущего.',
  },
  [QuoteIdsEnum.sberEcosystem]: {
    author: PersonIdsEnum.anna,
    text: 'Экосистемная роль «Сбера» — заставлять индустрию двигаться в сторону новых трендов.',
  },
};
